import { forwardRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import localeText from "../../locale";
import GetUserInfoService from "../../service/GetUserInfoService";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";

const getUserInfoService = new GetUserInfoService();

// Campo do código de segurança enviado por e-mail, que substituiu a antiga senha financeira.
// Cada clique em "Enviar código" gera um novo código e invalida o anterior.
const EmailSecurityCodeField = forwardRef(({ value, onChange, onFocus, disabled }, ref) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const sendCode = async () => {
    setSending(true);
    try {
      const res = await getUserInfoService.requestSecurityCode(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
      );
      if (res.messageCode !== 200000 && res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
        return;
      }
      setSent(true);
      showSuccessToast({ detail: "securityCodeSent" });
    } catch (e) {
      showErrorToast({ code: e?.response?.data?.messageCode || 500000 });
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <p className="mt-3 mb-2">{localeText("securityCodeLabel")}</p>
      <div className="flex gap-2 align-items-center">
        <InputText
          ref={ref}
          className="flex-1"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          disabled={disabled}
          autoComplete="one-time-code"
        />
        <Button
          type="button"
          label={localeText(sent ? "securityCodeResend" : "securityCodeSend")}
          className="p-button-outlined white-space-nowrap"
          loading={sending}
          disabled={disabled || sending}
          onClick={sendCode}
        />
      </div>
      <small className="block mt-2" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
        {localeText("securityCodeHint")}
      </small>
    </div>
  );
});

export default EmailSecurityCodeField;
